import * as S from "effect-app/Schema"
import { flag } from "./featureFlag.ts"

export const DeploymentCompany = S.Literals(["hausfux", "blizzz", "alfa", "hecht"])
export type DeploymentCompany = typeof DeploymentCompany.Type

export const featureFlagDefinitions = ({ company }: { company: string; env: string }) => {
  return {
    enableProjects: flag(
      company === "hausfux",
      "Projects feature in the web component (project list, add-to-project, cart projects). Consumed at runtime by the web component; defaults to on for hausfux."
    ),
    enableMinDxf: flag(
      company === "hausfux",
      "Multiple DXF optimizer nesting page in the backoffice (/min-dxf): DXF + order CSV upload, multi-sheet nesting via RunMinDXF, per-sheet DXF export."
    ),
    enablePriceBulkUpdate: flag(
      true,
      "Price bulk update page in the backoffice (/configurators/:id/prices): CSV import and inline bulk editing of prices and price IDs."
    ),
    enablePriceAi: flag(
      false,
      "AI chat assistant on the price bulk update page: turns a German instruction into a bulk edit of the current price draft. Billable per turn; enforced by the API, not only by the UI."
    ),
    enableLabelBulkUpdate: flag(
      true,
      "Label bulk update page in the backoffice (/configurators/:id/labels): CSV import and inline bulk editing of user-facing texts."
    ),
    enableLabelAi: flag(
      false,
      "AI chat assistant on the label bulk update page: turns an instruction into a draft of text edits. Billable per turn; enforced by the API, not only by the UI."
    ),
    enableConditionAi: flag(
      false,
      "AI \"Erklären\" button on the Bedingung detail page: explains the current draft of a condition group in German. Billable per call; enforced by the API, not only by the UI."
    ),
    enableTranslationsAi: flag(
      false,
      "AI chat assistant on the translations settings page: turns an instruction into a draft of translation override edits. Billable per turn; enforced by the API, not only by the UI."
    )
  }
}
